import { solidstate } from ":shared/utils/state-manager";
import type { ARequestProps } from "./_model";

export const $confirm_dialogs = solidstate.createGlobal<ARequestProps[]>([]);
export const actions = {
  pushConfirmDialog(props: ARequestProps) {
    $confirm_dialogs.set((s) => [...s, props]);
  },
};
